$(document).ready(function(){
  $(".cust_inputBox").change(function(){
    var get_Qty = $(this).children("option:selected", this).attr("value");
    
    $(".zooomyvariantselect option.cust-option").each(function(){
      var getopttext =  $(this).text();
      var trimStr = $.trim(getopttext);
      if(trimStr==get_Qty){
        // console.log("Matched");
        var GEt_DAta = $(this).attr("data-qty");
        // console.log(GEt_DAta+' GEt_DAta');
        var trimStr11 = $.trim(GEt_DAta);
        if(trimStr11==0){
          var texxt = $(".stock-message").text("out of stock");
          $(".cust_soldOUt_btn").css('display','block');
          $(".Cust_addCart").css('display','none');
          $(".cust_soldOUt_btn").attr ('disabled', 'disabled');
          $(".shopify-payment-button__button").attr ('disabled', 'disabled');
        }
        else
        {
          $(".stock-message").text("In stock");
          $(".cust_soldOUt_btn").css('display','none');
          $(".Cust_addCart").css('display','block');
          $(".shopify-payment-button__button").removeAttr ('disabled');
        }
      }
      else
      {
  
      }
    });

    $(".filter-flyout__filter").each(function(){
     var getAttr =  $(this).children('.filter-flyout__checkbox').text();
    });

}); 
  

 var GetUrl = window.location.href;
 // console.log("GetUrl " + GetUrl);
  
  const newText = GetUrl.replace("rkxc", "RKXC");
    //window.location = url.replace(newText);
 // location.replace(newText);
 
  $(".Cust_mobile-nav").click(function(){
    $(".drawer-menu").addClass("active visible");
     $('body').css("overflow", "hidden");
  });
   $(".drawer-menu__close .icon ").click(function(){
     console.log("Cust close");
    $(".drawer-menu").removeClass("active visible");
    $('body').removeAttr('style');
  });

  /* RKC search page */
  $(".CUst_Landing_Rkc .quick-search__trigger").click(function(){
    $(".quick-search").addClass("is-active");
  });

/* end RKC search page*/

  /* gift wrap functionality */
  $(".custmain_add").click(function(){
  var CuStMAinProID= $(".cust_Main_proID").text();
    console.log("CuStMAinProID " + CuStMAinProID);

    var quantityget = $(".quantity-txt").val();
    console.log(quantityget);

    var custfree = $('.cust-free-pro-id').text();
    console.log("custfree "+ custfree);
 
    if ($("#cust_check").is(":checked")) 
    {
      console.log("matched");
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
       data:{
          items:[
            {
              quantity: 1,
              id: custfree
            },
            {
              quantity: quantityget,
              id: CuStMAinProID
             }
            
          ]
         },
        dataType: 'json',
        success:function(form){
          console.log(form);
        }
      });
    }
    else
    {
      $('.shopify-product-form').serialize(),
      console.log("not checked");
    }                             
  });
  /* end product page gift wrap */



/* auto apply coupen code */
$(".cust_promo_code").click(function(){
var GetPRomoCode =$(this).children('span').text();
console.log("GetPRomoCode " + GetPRomoCode);
$('#devPromo').val(GetPRomoCode);
  if( !$('#devPromo').val() ) { 
    console.log('empty')
  }
  else{
   $("#redemDevPromo").trigger('click');
   console.log('not empty')
  }
});
 /* end auto apply coupen code */ 

/* Menu hover code */
 $('.nav__submenu').hide();
      $('.nav__item').hover(function () {
        if ($(this).find('.nav__submenu').length > 0) {
          $(this).find('.nav__submenu').stop().slideDown('slow');
        }
      },function () {
        if ($(this).find('.nav__submenu').length > 0) {
          $(this).find('.nav__submenu').stop().slideUp('slow');
        }
      });

/* end Menu hover code */

 /*-------- collection page product load more button start------*/
  var collectioncount = 0;
 
  $("#CollectionlodingBtn").click( function (e) {
   $(".LoaderGifImg").css("display","inline-block");
    $(".custm_collloding .cusldbtn").css("display","none");
    e.preventDefault();
    console.log("test load");
    var pageurl = $(this).attr('href');
    console.log(pageurl + 'first');
    $.ajax({
      type: 'GET',
      url: pageurl,
      dataType: 'html',
      success: function(data){
        $(".LoaderGifImg").css("display","none");
        var nextpagehtml = $(data).find(".collection__products").html();
        //console.log("nextpagehtml " + nextpagehtml );
         var loadbtnurl = $(data).find("#CollectionlodingBtn").attr('href');
         //console.log(loadbtnurl);
         $('.collection__products').append(nextpagehtml);
        
        $("#CollectionlodingBtn").attr('href' , loadbtnurl); 
        if($(".cusldbtn").attr("href") == "") {
          $(".custm_collloding").css('display','none');
        }else{
          $(".custm_collloding .cusldbtn").css("display","inline-block");
        }
      } 
    });
  });
  /*-------- collection page product load more button end ------*/
/*Home best seller */

  $('.cust-best-seller1').owlCarousel({
    loop:true,
    dots:false,
    loop:true,
    arrow:true,
    autoplay:true,
    autoplaySpeed: 600,
    responsiveClass:true,
    navText : ["<i class='fa fa-arrow-left' aria-hidden='true'></i>","<i class='fa fa-arrow-right' aria-hidden='true'></i>"],
    responsive:{
      0:{
        items:1,
        nav:true,
        loop:true,
        lazyLoad: true,
        lazyContent:true
      },
      600:{
        items:3,
        nav:true,
        loop:true,
        lazyLoad: true,
        lazyContent:true
      },
      1000:{
        items:5,
        nav:true,
        loop:true,
        lazyLoad: true,
        lazyContent:true
      }
    }
  });
  
  $('#as_seen_in').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
     autoplay:true,
    autoplayTimeout:1000,
    autoplayHoverPause:true,
    responsive:{
        0:{
            items:2
        },
        600:{
            items:3
        },
        1000:{
            items:5
        }
    }
})
// $('.cust-best-seller').slick({
//   dots: false,
//   infinite: true,
//   arrows: true,
//   autoplay: true,
//   draggable: false,
//   // centerMode: true,
//   speed: 1000,
//   slidesToShow: 5,
//   slidesToScroll: 1,
//   prevArrow:"<i class='fa fa-arrow-left' aria-hidden='true'></i>",
//   nextArrow:"<i class='fa fa-arrow-right' aria-hidden='true'></i>",
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: true,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         arrows: true,
//         centerMode: false,
//         slidesToShow: 1,
//         draggable: false
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         arrows: true,
//         centerMode: false,
//         slidesToShow: 1,
//         draggable: false
//       }
//     }
//   ]
// });
  /*end Home best seller */
  
// $('.cust_instashop_slider').slick({
//   dots: false,
//   arrow:true,
//   autoplay: true,
//   draggable: false,
//   infinite: true,
//   speed: 400,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   prevArrow:"<i class='fa fa-arrow-left' aria-hidden='true'></i>",
//   nextArrow:"<i class='fa fa-arrow-right' aria-hidden='true'></i>"
// });


// var ww = document.body.clientWidth;
//   if (ww >1024) {
//     $('.cust-best-seller .slick-list').addClass('cust_slick_list');
//   } 

 $(".nav--depth-2 .nav__item").hover(function (){
   $(this).children(".nav__link").next(".nav--depth-3").toggleClass("cust_menu_hover");
  });



/* Size chart popup */
 // var newhtml= '<div class="custm_fit_size custSizenew"><a id="inline" href="#pop-up">Size Guide</a></div>';
 // $("a#inline").fancybox(); 

 //   var newhtml= '<div class="custm_fit_size custSizenew"><a id="inline_kurta" href="#pop-up">Size Guide</a></div>';
 // $("a#inline_kurta").fancybox(); 

 //   var newhtml= '<div class="custm_fit_size custSizenew"><a id="inline_jacket" href="#pop-up">Size Guide</a></div>';
 // $("a#inline_jacket").fancybox(); 
/* end size chart  popup*/
  
}); 
$(document).ready(function(){
//jQuery('#so-tab-7').prop('checked', true);
jQuery('#so-tab-8').prop('checked', true);
jQuery('#so-tab-1').prop('checked', false);
  
});
   
/* review date change sanjeev */
   

setTimeout(function(){
console.log('custom js');
$('span.spr-review-header-byline strong:nth-child(2)').each(function(){
	$(this).text(randomDate('06/13/2023', '06/14/2021'));
})
function randomDate(date1, date2){
    function randomValueBetween(min, max) {
      return Math.random() * (max - min) + min;
    }
    var date1 = date1 || '01-01-1970'
    var date2 = date2 || new Date().toLocaleDateString()
    date1 = new Date(date1).getTime()
    date2 = new Date(date2).getTime()
    if( date1>date2){
        return new Date(randomValueBetween(date2,date1)).toLocaleDateString()   
    } else{
        return new Date(randomValueBetween(date1, date2)).toLocaleDateString()  

    }
}
},3500);


<!------sticky add to cart------>
document.addEventListener("DOMContentLoaded", function () {
    let footer = document.querySelector(".custom-pro-wishlist-row");

    // Function to check if the screen size is mobile
    function isMobile() {
          return window.innerWidth <= 768; // Adjust breakpoint as needed
    }

    function checkScroll() {
        if (!isMobile()) {
            footer.classList.remove("visible");
            return; // Stop execution on desktops
        }

        let scrollPosition = window.scrollY; 
        let totalHeight = document.documentElement.scrollHeight; 
        let windowHeight = window.innerHeight; 
        let scrollPercentage = (scrollPosition / (totalHeight - windowHeight)) * 100;

        if (scrollPercentage >= 5) { 
            footer.classList.add("visible");
        } else {
            footer.classList.remove("visible");
        }
    }

    window.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll); // Re-check on resize
    checkScroll(); // Initial check on page load
});
 <!------end sticky add to cart------>